var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"font-poppins-light fs-lg-0 text-white mb-1"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"font-poppins-semibold text-white mb-3",class:{'fs-lg-2': _vm.valueFontSize ==='lg'}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }